module.exports = __webpack_public_path__ + "img/1c2d707.png";